import api from '../services/api';

export const permissionsApi = {
  /** Capabilities efetivas do perfil da sessão atual. */
  getMine: () => api.get('/permissions/me').then((r) => r.data),

  /** Matriz completa para a tela de administração (admin). */
  getMatrix: () => api.get('/permissions/matrix').then((r) => r.data),

  /** Grava o conjunto inteiro de overrides — não é patch. */
  saveMatrix: (overrides: Record<string, string[]>) =>
    api.put('/permissions/matrix', { overrides }).then((r) => r.data),

  /** Restaura o default de uma capability. */
  clearOverride: (capability: string) =>
    api.delete(`/permissions/matrix/${encodeURIComponent(capability)}`).then((r) => r.data),
};
